<div class="content-rail">
  <cigna-leaf-loading-spinner
    size="large"
    class="loader"
  ></cigna-leaf-loading-spinner>
  <div class="cdsso-content">
    <h3>Redirecting...</h3>
    <p>You are being logged in to the EPP site.</p>
  </div>
</div>
